<template>
    <div
        class="message-hover-wrapper"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
        @touchstart.passive="onTouchStart"
        @touchend="onTouchEnd"
        @touchmove="onTouchCancel"
    >
        <!-- message content -->
        <slot name="message" />

        <!-- hover actions -->
        <div
            class="hover-actions-wrapper"
            :class="[`pos-${position}`, { visible: isVisible }]"
            ref="wrapper"
            @click.stop="close"
        >
            <slot name="actions" />
        </div>
    </div>
</template>

<script lang="ts" src="./MessageHoverActions.ts"></script>
<style lang="scss" src="./MessageHoverActions.scss"></style>
